module.exports = __webpack_public_path__ + "static/schedule_call_banner_2x-460617f312fd13c3cb1d41332a9ff497.png";